import { AxiosAdapter } from "../../../_config/adapters/axios/axios.adapter"
import { Http } from "../../../_config/adapters/axios/axios.protocols"
import { Enviroment } from "../../../_config/constants/enviroment-v2.constant"

/**
 * Clase de servicio para operaciones de usuarios
 * Implementa el patrón de repositorio para acceso a datos
 */
export class Service {
    /**
     * Obtiene todos los usuarios
     * @param {Object} params - Parámetros de la petición
     * @param {string} params.token - Token de autenticación
     * @returns {Promise<Array>} - Lista de usuarios
     */
    async getUsers({ token }) {
        return new AxiosAdapter({
            method: Http.GET,
            url: `${Enviroment.API_PHARMACY}/user-panel/get-users`,
            headers: {
                Authorization: `Bearer ${token}`,
            },
        })
            .request()
            .then((response) => {
                return response
            })
            .catch((e) => {
                console.error("Error al obtener usuarios:", e)
                throw e
            })
    }

    /**
     * Obtiene los datos del usuario actual
     * @param {Object} params - Parámetros de la petición
     * @param {string} params.token - Token de autenticación
     * @returns {Promise<Object>} - Datos del usuario
     */
    async getMe({ token }) {
        return new AxiosAdapter({
            method: Http.GET,
            url: `${Enviroment.API_PHARMACY}/user-panel/get-me`,
            headers: {
                Authorization: `Bearer ${token}`,
            },
        })
            .request()
            .then((response) => {
                return response
            })
            .catch((e) => {
                console.error("Error al obtener datos del usuario:", e)
                throw e
            })
    }

    /**
     * Actualiza los datos del usuario actual
     * @param {Object} params - Parámetros de la petición
     * @param {string} params.token - Token de autenticación
     * @param {Object} params.data - Datos a actualizar
     * @returns {Promise<Object>} - Datos actualizados
     */
    async updateMe({ token, data }) {
        return new AxiosAdapter({
            method: Http.PUT,
            url: `${Enviroment.API_PHARMACY}/user-panel/update-me`,
            headers: {
                Authorization: `Bearer ${token}`,
            },
            data,
        })
            .request()
            .then((response) => {
                return response
            })
            .catch((e) => {
                console.error("Error al actualizar datos del usuario:", e)
                throw e
            })
    }

    /**
     * Crea un nuevo usuario
     * @param {Object} params - Parámetros de la petición
     * @param {string} params.token - Token de autenticación
     * @param {Object} params.data - Datos del nuevo usuario
     * @returns {Promise<Object>} - Usuario creado
     */
    async createUser({ token, data }) {
        return new AxiosAdapter({
            method: Http.POST,
            url: `${Enviroment.API_PHARMACY}/user-panel`,
            headers: {
                Authorization: `Bearer ${token}`,
            },
            data,
        })
            .request()
            .then((response) => {
                return response
            })
            .catch((e) => {
                console.error("Error al crear usuario:", e)
                throw e
            })
    }

    /**
     * Actualiza un usuario
     * @param {Object} params - Parámetros de la petición
     * @param {string} params.token - Token de autenticación
     * @param {Object} params.data - Datos a actualizar
     * @returns {Promise<Object>} - Usuario actualizado
     */

    async updateUser({ token, data }) {
        return new AxiosAdapter({
            method: Http.PUT,
            url: `${Enviroment.API_PHARMACY}/user-panel/update-user`,
            headers: {
                Authorization: `Bearer ${token}`,
            },
            data,
        })
            .request()
            .then((response) => {
                return response
            })
            .catch((e) => {
                console.error("Error al actualizar usuario:", e)
                throw e
            })
    }

    /**
     * Cambia la contraseña del usuario
     * @param {Object} params - Parámetros de la petición
     * @param {string} params.token - Token de autenticación
     * @param {Object} params.data - Datos de la nueva contraseña
     * @returns {Promise<Object>} - Respuesta del servidor
     */
    async changePassword({ token, data }) {
        return new AxiosAdapter({
            method: Http.POST,
            url: `${Enviroment.API_PHARMACY}/user-panel/change-password`,
            headers: {
                Authorization: `Bearer ${token}`,
            },
            data,
        })
            .request()
            .then((response) => {
                return response
            })
            .catch((e) => {
                console.error("Error al cambiar contraseña:", e)
                throw e
            })
    }

    /**
     * Busca un usuario por email
     * @param {Object} params - Parámetros de la petición
     * @param {string} params.token - Token de autenticación
     * @param {string} params.email - Email del usuario
     * @returns {Promise<Object>} - Datos del usuario
     */
    async findUser({ token, email }) {
        return new AxiosAdapter({
            method: Http.GET,
            url: `${Enviroment.API_PHARMACY}/user-panel/get-by-email/${email}`,
            headers: {
                Authorization: `Bearer ${token}`,
            },
        })
            .request()
            .then((response) => {
                return response
            })
            .catch((e) => {
                console.error("Error al buscar usuario:", e)
                throw e
            })
    }

    /**
     * Obtiene la lista de farmacias
     * @returns {Promise<Array>} - Lista de farmacias
     */
    async getPharmacies() {
        return new AxiosAdapter({
            method: Http.GET,
            url: `${Enviroment.FRONT_COMMON}/pharmacies/${Enviroment.LANGUAGE}`,
        })
            .request()
            .then((response) => {
                return response
            })
            .catch((e) => {
                console.error("Error al obtener farmacias:", e)
                throw e
            })
    }
}
